export const actionTypes = {
  TRANSPORT_ORDER_MANAGEMENT_SET_FILTER:
    'TRANSPORT_ORDER_MANAGEMENT_SET_FILTER',
};

export default actionTypes;
